export enum HeaderTabsEnum {
  INFORMATION = "information",
  COLLEAGUES = "colleagues",
  TASKS = "tasks",
  WAREHOUSE = "warehouse",
  TRANSPORT = "transport",
  SETTINGS = "settings",
  HISTORY = "history",
}
